<div class="dialog">
  <h2>Add link</h2>
  <form [formGroup]="addLinkForm">
    <div class="form-group">
      <label for="url">Link*</label>
      <input
        type="url"
        formControlName="url"
        placeholder="https://example.com"
        required
      />
      <div class="text-danger smaller-text" *ngIf="addLinkForm.get('url')?.hasError('pattern')">
        Please enter a valid link
      </div>
    </div>
    <div class="actions">
      <button type="button" class="btn-cancel mt-3" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn-add"
        (click)="onAdd()"
        [disabled]="addLinkForm.invalid">
        Add link
      </button>
    </div>
  </form>
</div>
